
import './ext_install_pop.scss';
import { nxtInstallCall  } from '../../apicall';
const { __ } = wp.i18n;
import { useState, useEffect } from 'react';

var plugin_url = nxtext_ajax_object.nxtex_url;

const ExtensionInstallPopup = ({ isPopupExtensionInstall, setIsPopupExtensionInstall }) => {

    useEffect(() => {
        const handleClickOutside = (event) => {
            if ( !event.target.closest('.nxtext_block_tgl_btn_cover') && event.target.className !== 'nxt-ex-btn' && event.target.className !== 'nxtext_blue_common_btn' ) {
                setIsPopupExtensionInstall(false);
            }
        };

        const handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                setIsPopupExtensionInstall(false);
            }
        };

        document.body.addEventListener('click', handleClickOutside);
        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.body.removeEventListener('click', handleClickOutside);
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, []);

    return (
        <>
            <div className='nxt_whitlabel_overlay'></div>
            <div className={'nxt_ext_whitlabel_popup'}>
                <img className='nxtext_close_icon' src={`${plugin_url}assets/svg/cross-icon.svg`} draggable={false} onClick={() => setIsPopupExtensionInstall(false)} />
                <h4 className='nxtext_primary_heading'>{ __("Install Nexter Extension to Unlock this Feature.", 'nexter-extension') }</h4>
                <ul className='nxt_popup_style_list'>
                    <li className='nxt_popup_list_icon'><img src={plugin_url + 'assets/svg/upgrade_table/nxt_white_check.svg'} alt="Check Icon" />{__('Replace 50+ WordPress Plugins', 'nexter-extension')}</li>
                    <li className='nxt_popup_list_icon'><img src={plugin_url + 'assets/svg/upgrade_table/nxt_white_check.svg'} alt="Check Icon" />{__('Theme Builder & Code Snippets', 'nexter-extension')}</li>
                    <li className='nxt_popup_list_icon'><img src={plugin_url + 'assets/svg/upgrade_table/nxt_white_check.svg'} alt="Check Icon" />{__('Modular Code', 'nexter-extension')}</li>
                </ul>
                <a className='nxtext_blue_common_btn' style={{ width: '230px' }} onClick={(e) => (nxtInstallCall(e, true, 'nexter-extension') )}>{nxtext_ajax_object?.dashData?.extensionactivate ? __('Activate Now', 'nexter-extension') : __('Install Now', 'nexter-extension')}</a>
            </div>
        </>
    );
};

export default ExtensionInstallPopup;